<template>
    <header class="head">

        <div class="wd16">
            <div class="logo">
<!--                <img alt="Vue logo" src="../assets/logo.png">-->
                <h3 v-if="baseerp=='havay'"style="white-space:nowrap">{{ $t('login_title') }}</h3>
                <h3 v-else style="white-space:nowrap">{{ $t('login_title') }}</h3>
            </div>
        </div>


        <div class="userinfo">

            <div >
                <span>{{ $t('langsetting') }}</span>
                <el-select size="mini" style="width: 120px;margin-left: 8px;margin-right: 8px" v-model="vc_lang"  @change="langChange" >
                    <el-option
                            v-for="item in langList"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>
            <div>{{ $t('header_welcome') }} <span style="color: #fff ;">{{nameuser}}</span> </div>
            <div style="display: flex">
                <span style="padding: 0 10px">|</span>
                <div @click="logout" style="cursor: pointer"> {{ $t('header_exit') }} </div>
            </div>


        </div>

    </header>
</template>

<script>
    import * as API from "../api/global";
    import {baseerp} from "../utils/baseUrl";
    import { mapState } from "vuex"
    import {mapActions} from "vuex"
    import {language} from './../locales/selection'
    export default {
        name: "HelloWorld",
        props: {
            msg: String,
        },
        data(){
            return {
                nameuser:'',
                affixTags:[],
                baseerp:"",
                langList:[],
                vc_lang:sessionStorage.getItem("vc_lang")

            }
        },
        mounted() {
            //console.log(baseerp)
            this.baseerp=baseerp;
            this.langList=language;
            this.nameuser=sessionStorage.getItem("loginuser");
            this.vc_lang=sessionStorage.getItem("vc_lang")?sessionStorage.getItem("vc_lang"):'zh_cn';
        },
        computed:{
            ...mapState(["routerList"])
        },
        methods:{
            ...mapActions(["delAllVisitedViews"]),
            langChange(){
                sessionStorage.setItem("vc_lang", this.vc_lang);
                this.$i18n.locale=this.vc_lang;
                let str={ path: '/home/desk.vue',
                    name: 'home/desk.vue',
                    component: () => import('@/views/home/desk.vue'),
                    meta:{title:this.$t('menu_index')}

                };
                sessionStorage.setItem('routerList', JSON.stringify([str]));
                sessionStorage.setItem('activeIndex','home/desk.vue')
                this.$store.commit('set_routerList_clear',str)
                // this.$router.push({ path: "/home/desk.vue" });
                // this.$router.replace({ path: "/home/desk.vue" });
                // location.reload()
                location.replace('/#/home/desk.vue');
                location.reload()
            },
            logout(){
                this.$confirm(this.$t('header_confirm_exit'), this.$t('tips_confirm_exit_tips'), {
                    confirmButtonText:this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type: 'warning'
                }).then(()=>{
                    this.getout();

                }).catch(() => {
                });

            },
            closeAllTags(view){
                this.$store.dispatch()
            },

            async getout(){
                let param = {
                    i_uid:sessionStorage.getItem("userid"),
                    token:sessionStorage.getItem("token"),
                    app: 'masterdata',
                    version: "1.0"
                };
                let res = await API.logout(param);
                if (res.code == 1) {//退出成功
                    // sessionStorage.removeItem("loginuser");
                    sessionStorage.removeItem("userid");
                    sessionStorage.removeItem("token");
                    sessionStorage.removeItem("nickname");
                    sessionStorage.removeItem("uuid");
                    // sessionStorage.removeItem("vc_language");
                    sessionStorage.removeItem("vc_name");
                    sessionStorage.removeItem("userType");
                    this.$store.commit('changeLogin','logout')
                    this.delAllVisitedViews();
                    this.$router.push('/login')
                } else if(res.code==-2){//身份验证失败
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else {
                    this.$message.error(res.message);
                }

            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
    .head {
        display: flex;
        align-items: center;
        padding: 0 20px;
        background: var(--light);
        justify-content: space-between;
        height: 60px;
        color: var(--whiteColor);
    }
    .wd16{
        display: flex;

        .logo{
            h3{
                margin: 0;
                width:250px;
            }
            img{
                margin: 10px;
                width: 60px;
                height: 36px;
            }
        }
    }
    .userinfo{
        display: flex;
        justify-content: space-around;
        color: var(--whiteColor);
        font-size: 14px;
        align-items: center;
    }
    /deep/{
        .el-select-dropdown__item{
            display: block !important;
        }
    }
    .el-select-dropdown__item{
        display: block !important;
    }
</style>
